<template>
  <div>
    <section class="tables">
      <b-container>
        <b-row>
          <!-- Route Title -->
          <b-col cols="4">Route Title</b-col>
          <b-col cols="8">{{ modalData?.routeId_title || "-" }}</b-col>

          <!-- User Name -->
          <b-col cols="4">Name</b-col>
          <b-col cols="8">{{ modalData?.userId_fullname || "-" }}</b-col>

          <!-- Email -->
          <b-col cols="4">Email</b-col>
          <b-col cols="8">{{ modalData?.userId_email || "-" }}</b-col>

          <!-- Phone -->
          <b-col cols="4">Phone</b-col>
          <b-col cols="8">{{ modalData?.userId_phone || "-" }}</b-col>

          <!-- User Preferred Home -->
          <b-col cols="4">User preferred Home address</b-col>
          <b-col cols="8">
            <div v-if="modalData?.user_pickup_address">
              {{ modalData.user_pickup_address }}
              <b-button
                v-if="modalData.user_pickup_stop"
                size="sm"
                variant="primary"
                class="ml-2"
                @click="openMap(modalData.user_pickup_stop)"
              >
                View on Map
              </b-button>
            </div>
            <div v-else>-</div>
          </b-col>

          <!-- User Preferred Office -->
          <b-col cols="4">User preferred Office address</b-col>
          <b-col cols="8">
            <div v-if="modalData?.user_drop_address">
              {{ modalData.user_drop_address }}
              <b-button
                v-if="modalData.user_drop_stop"
                size="sm"
                variant="primary"
                class="ml-2"
                @click="openMap(modalData.user_drop_stop)"
              >
                View on Map
              </b-button>
            </div>
            <div v-else>-</div>
          </b-col>

          <!-- Admin Selected Pickup -->
          <b-col cols="4">New Pickup Stop</b-col>
          <b-col cols="8">
            <b-form-select
              v-model="pickupStopId"
              :options="stopOptions"
              size="sm"
            />
          </b-col>

          <!-- Admin Selected Drop -->
          <b-col cols="4">New Drop Stop</b-col>
          <b-col cols="8">
            <b-form-select
              v-model="dropoffStopId"
              :options="stopOptions"
              size="sm"
            />
          </b-col>

          <!-- Save -->
          <b-col cols="12" class="text-right mt-3">
            <b-button
              variant="success"
              size="sm"
              :disabled="!canSave"
              @click="saveStops"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import { requestRouteService } from "@/services/requestRoute.service";

export default {
  name: "RequestRouteView",
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      stops: [],
      pickupStopId: "",
      dropoffStopId: ""
    };
  },

  computed: {
    stopOptions() {
      return [
        { value: "", text: "Select stop" },
        ...this.stops.map(s => ({
          value: s.stopId._id,     // ✅ UNIQUE
          text: s.stopId.title     // display only
        }))
      ];
    },

    canSave() {
      return (
        this.pickupStopId &&
        this.dropoffStopId &&
        this.pickupStopId !== this.dropoffStopId
      );
    }
  },

  mounted() {
    this.fetchStops().then(() => {
      // ✅ Correct prefill using IDs
      const pickupTitle = this.modalData?.pickupStopTitle;
      const dropoffTitle = this.modalData?.dropoffStopTitle;


      this.pickupStopId = this.stops.find(s => s.stopId.title === pickupTitle)?.stopId._id || "";

      this.dropoffStopId =this.stops.find(s => s.stopId.title === dropoffTitle)?.stopId._id || "";
    });
  },

  methods: {

    getStopTitleById(id) {
      return (
        this.stops.find(s => s.stopId._id === id)?.stopId.title || ""
      );
    },

    openMap(coords) {
      if (!coords || coords.length < 2) return;
      const [lng, lat] = coords;
      window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
    },

    async fetchStops() {
      try {
        const res = await requestRouteService.getAllStops(this.modalData._id);
        this.stops = res?.data || [];
      } catch (err) {
        console.error("Fetch stops failed", err);
      }
    },

    async saveStops() { 
      try {
        const pickupStopTitle = this.getStopTitleById(this.pickupStopId);
        const dropoffStopTitle = this.getStopTitleById(this.dropoffStopId);
        const response = await requestRouteService.updateRequestRouteStops(
          this.modalData._id,
          {
            pickupStopTitle: pickupStopTitle,
            dropoffStopTitle: dropoffStopTitle
          }
        );
        console.log("Stops updated successfully", response);

        if (response.status) {
            this.$toast.open({
              message: response.message,
              type: "success",
              position: "top-right",
              duration: 2000,
              // all of other options may go here
            });   
        } else {
          // console.log("create response", this.form);
          // const response = await locationService.create(this.form);
          
            this.$toast.open({
              message: "Failed to save stops",
              type: "success",
              position: "top-right",
              duration: 2000,
              // all of other options may go here
            });
        }
        this.modalData.pickupStopId = this.pickupStopId;
        this.modalData.dropoffStopId = this.dropoffStopId;

        this.$bvToast.toast("Stops saved successfully", {
          variant: "success",
          solid: true
        });

      } catch (err) {
        console.error("Save stops failed", err);
        this.$bvToast.toast("Failed to save stops", {
          variant: "danger",
          solid: true
        });
      }
    }
  }
};
</script>

<style scoped>
.ml-2 {
  margin-left: 0.5rem;
}
</style>
